import { lazy } from "react";

export const digitalDashboard = [
  {
    Path: "/digital/*",
    Component: lazy(() => import("../../container/DigitalDashboard/routes.js")),
    meta: {
      name: "Digital Dashboard",
    },
  },
];
